
export class RegistrationParent {

    motherName: string;
    fatherName: string;

    constructor() {
        this.motherName = null;
        this.fatherName = null;
    }

}


// WEBPACK FOOTER //
// ./src/models/registrationparent.ts